<script setup lang="ts">
import { computed } from "vue";

import { ClientName, useClientStore } from "@/stores/clientStore";

import PhoneIcon from "@/components/icons/PhoneIcon.vue";
import WhatsappIcon from "@/components/icons/WhatsappIcon.vue";
import { storeToRefs } from "pinia";

const clientStore = useClientStore();

const {
  client,
  whatsappNumber: whatsapp,
  phoneNumber: phone,
  headerTheme,
} = storeToRefs(clientStore);

const showContactNumber = computed(() => {
  return (
    client.value !== ClientName.Rapihogar &&
    client.value !== ClientName.Meridional &&
    client.value !== ClientName.Soelsac &&
    client.value !== ""
  );
});
</script>

<template>
  <header
    :class="headerTheme"
    class="nav-bar from-skin-gradient-from to-skin-gradient-to shadow-md shadow-gray-500 z-10"
  >
    <div class="nav-bar-size">
      <div class="nav-bar-position">
        <!-- <LogoRus
          svgColor="#FFFFFF"
          v-if="clientStore.client === 'rus'"
          class="text-white logo-size h-7 my-0 md:h-12 md:my-1"
        /> -->
        <img
          v-if="client === 'rapihogar' || client === 'rus'"
          class="logo-size"
          src="@/assets/vaitty_navbar_desktop.svg"
          alt="Rapi Hogar"
        />
        <img
          v-if="client === 'galicia'"
          class="logo-size w-20 md:w-[105px]"
          src="@/assets/logo_galicia.svg"
          alt="Galicia"
        />
        <img
          v-if="client === 'meridional'"
          class="logo-size w-40 md:w-[178px] my-1 md:my-4"
          src="@/assets/logo_meridional.svg"
          alt="Meridional"
        />
        <img
          v-if="client === 'soelsac'"
          class="logo-size w-20 md:w-[130px]"
          src="@/assets/logo_soelsac.svg"
          alt="Soelsac"
        />

        <div v-if="showContactNumber" class="flex gap-9 text-skin-iconalt">
          <div class="hidden md:flex items-center">
            <WhatsappIcon />
            <span
              class="pl-2 font-montserrat font-medium text-sm 2xl:text-base"
            >
              {{ whatsapp }}</span
            >
          </div>
          <div class="hidden md:flex items-center">
            <PhoneIcon />
            <span
              class="pl-2 font-montserrat font-medium text-sm 2xl:text-base"
            >
              {{ phone }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<style scoped></style>
